if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      const timezone = this.dataset.timezone,
        date = this.dataset.date.split("-").filter(function (el) { return el != ""; }),
        day = parseInt(date[0]),
        month = parseInt(date[1]),
        year = parseInt(date[2]);

      let time = this.dataset.time,
        tarhour,
        tarmin;

      if (time != null) {
        time = time.split(":");
        tarhour = parseInt(time[0]);
        tarmin = parseInt(time[1]);
      }

      // Set the date we're counting down to
      let date_string =
        month +
        "/" +
        day +
        "/" +
        year +
        " " +
        tarhour +
        ":" +
        tarmin +
        " GMT" +
        timezone;
      // Time without timezone
      this.countDownDate = new Date(
        year,
        month - 1,
        day,
        tarhour,
        tarmin,
        0,
        0
      ).getTime();

      // Time with timezone
      this.countDownDate = new Date(date_string).getTime();
    }

    convertDateForIos(date) {
      var arr = date.split(/[- :]/);
      date = new Date(
        arr[0],
        arr[1] - 1,
        arr[2],
        arr[3],
        arr[4],
        arr[5]
      );
      return date;
    }
    connectedCallback() {
      let _this = this;
      let timer_layout = _this.dataset.timerLayout;
      let timer_ended_message = _this.dataset.endMessage;

      const updateTime = function () {
        // Get todays date and time
        const now = new Date().getTime();

        // Find the distance between now an the count down date
        const distance = _this.countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (distance % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        let countdownTimerColumns = _this.querySelector(
          ".countdown-timer__date-container"
        );
        let countdownTimerMessage = _this.querySelector(
          ".countdown-timer__message"
        );

        // set .countdown-timer__date-header blocks
        let daysBlock = _this.querySelector(
          ".days .countdown-timer__date-header"
        );
        let hoursBlock = _this.querySelector(
          ".hours .countdown-timer__date-header"
        );
        let minutesBlock = _this.querySelector(
          ".minutes .countdown-timer__date-header"
        );
        let secondsBlock = _this.querySelector(
          ".seconds .countdown-timer__date-header"
        );

        if (distance < 0) {
          if (daysBlock) daysBlock.innerHTML = 0;
          if (hoursBlock) hoursBlock.innerHTML = 0;
          if (minutesBlock) minutesBlock.innerHTML = 0;
          if (secondsBlock) secondsBlock.innerHTML = 0;

          _this.classList.add("loading-effect");

          // update data-is-ended attribute
          _this.setAttribute("data-is-ended", "true");

          let countdownTimerParent = _this.parentElement;
          let countdownTimerTitle = countdownTimerParent.querySelector('.countdown-timer__title');
          if (countdownTimerTitle)
            countdownTimerTitle.innerHTML =
              _this.dataset.endMessage;
          if (daysBlock)
            daysBlock.parentElement.parentElement.remove();
        } else {
          requestAnimationFrame(updateTime);

          if (daysBlock)
            daysBlock.innerHTML = CountdownTimer.addZero(days);
          if (hoursBlock)
            hoursBlock.innerHTML = CountdownTimer.addZero(hours);
          if (minutesBlock)
            minutesBlock.innerHTML = CountdownTimer.addZero(minutes);
          if (secondsBlock)
            secondsBlock.innerHTML = CountdownTimer.addZero(seconds);

          // if days is 0, remove the days block
          if (days === 0) {
            if (daysBlock)
              daysBlock.parentElement.parentElement.remove();
          }

          _this.classList.remove("loading-effect");
        }
      };
      requestAnimationFrame(updateTime);
    }
    static addZero(x) {
      return x < 10 && x >= 0 ? "" + x : x;
    }
  }
  customElements.define("countdown-timer", CountdownTimer);

}
